module.exports = __webpack_public_path__ + "0af1727ae9198ebfe2aa8c85fc95cd89.png";